@if (entries?.length) {
  @for (entry of entries; track $index) {
    <div class="workflow-entry mb-[20px]">
      <div class="flex flex-row items-start gap-[12px]">
        <div class="workflow-icon">
          <mat-icon class="text-[#36AB19]">check_circle</mat-icon>
        </div>
        <div class="flex flex-col flex-1">
          <div class="entry-action text-type-8">{{ entry.action }}</div>
          <div class="flex flex-row items-center gap-[8px] mt-[8px]">
            <div class="avatar">{{ entry.actor_initials }}</div>
            <div class="flex flex-col">
              <span class="text-type-11">{{ entry.actor_name }}</span>
            </div>
          </div>
          <div class="text-type-14 text-[#60698B] mt-[4px]">
            {{ entry.date | date:'MMM d, y' }} &bull; {{ entry.date | date:'h:mm a' }}
          </div>
          @for (detail of entry.details || []; track detail.label) {
            <div class="comment-section mt-[12px]">
              <div class="comment-label text-type-13 uppercase">{{ detail.label }}:</div>
              <div class="comment-text text-type-11 mt-[4px]">{{ detail.value }}</div>
            </div>
          }
          @if (entry.forwarded_to?.length) {
            <div class="comment-section mt-[12px]">
              <div class="comment-label text-type-13 uppercase">{{ recipientsLabel }}:</div>
              <div class="comment-text text-type-11 mt-[4px]">{{ entry.forwarded_to.join(', ') }}</div>
            </div>
          }
          @if (entry.notes) {
            <div class="comment-section mt-[12px]">
              <div class="comment-label text-type-13 uppercase">Comment:</div>
              <div class="comment-text text-type-11 mt-[4px]">{{ entry.notes }}</div>
            </div>
          }
          @if (entry.attachments?.length) {
            <div class="comment-section mt-[12px]">
              <div class="comment-label text-type-13 uppercase">Media:</div>
              <div class="pictures-row flex flex-wrap gap-[12px] mt-[8px]">
                @for (attachment of entry.attachments; track attachment.id) {
                  <div
                    (click)="openAttachment($event, entry, attachment)"
                    (keydown.enter)="openAttachment($event, entry, attachment)"
                    class="picture-block"
                    role="button"
                    tabindex="0">
                    <app-image
                      [url]="attachment.thumb_url || attachment.original_url"
                      class="each-picture"
                    />
                  </div>
                }
              </div>
            </div>
          }
        </div>
      </div>
      <hr class="entry-divider" />
    </div>
  }
} @else {
  <div class="no-data text-type-14 text-[#60698B] text-center py-[40px]">{{ emptyText }}</div>
}
